import React, { useEffect, useState } from 'react';
import _ from 'lodash';

import { ClearIcon } from './icons/ClearIcon';
import { messageUtility } from '../utilities/messageUtility';

const ErrorImportExcel = ({
  title,
  onCloseMessage,
  messageErrors = [],
  showBtnClose = true,
}) => {
  const [isScroll, setIsScroll] = useState(false);

  useEffect(
    () => {
      if (_.size(messageErrors) > 5) {
        setIsScroll(true);
      }
    },
    [messageErrors]
  );
  const getTotalErrorMessage = () => {
    const totalErrors = _.size(messageErrors);
    if (totalErrors > 50) {
      return 50;
    }
    return totalErrors;
  };
  return (
    <div className='ErrorImportExcel'>
      <div className='ErrorImportExcel__header'>
        <div className='ErrorImportExcel__header--title'>
          {title ||
            messageUtility.getMessage('I-000-169', getTotalErrorMessage())}
        </div>
        {showBtnClose && (
          <button className='btn--sub btn-close' onClick={onCloseMessage}>
            {messageUtility.getMessage('I-000-017')}
            <ClearIcon className='icon--2x icon-close' />
          </button>
        )}
      </div>
      <ul
        className={
          isScroll
            ? 'ErrorImportExcel__message ErrorImportExcel__message--scroll'
            : 'ErrorImportExcel__message'
        }
      >
        {_.map(messageErrors, message => (
          <li className='ErrorImportExcel__message--item'>{message}</li>
        ))}
      </ul>
    </div>
  );
};

export default ErrorImportExcel;



// WEBPACK FOOTER //
// ./src/components/ErrorImportExcel.jsx